// src/PageTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./analytics";

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap") {
      return;
    }
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

